module.exports = __webpack_public_path__ + "img/AC.6468b829.svg";